<template>
  <div>
    <div
      class="exam-item"
      :class="exam.status == 1 ? 'exam-item not-buy' : 'exam-item'"
      @click="notBuyTips()"
    >
      <div class="exam-left">
        <img class="exam-icon" src="@/assets/images/course/course-exam@2x.png" />
        <div class="title">
          <div class="exam-title">{{ exam.name }}</div>
          <div class="num-score">
            <div>试题总数：{{ exam.ques_num }}</div>
            <div class="line-score"></div>
            <div>考试总分：{{ exam.score }}分</div>
          </div>
        </div>
      </div>
      <div class="exam-right">
        <span v-if="showDetailBtn" @click.stop="toDetail()">查看详情</span>
        <span class="active" v-if="showJoinBtn" @click.stop="joinTest()">
          {{ exam.status == 6 ? '继续考试' : '参加考试' }}
        </span>
      </div>
    </div>
    <TestConditionModal :showModal.sync="showModal" :testCondition="testCondition" />
    <TestingModal :showModal.sync="showTipsModal" :remindType="remindType" />
  </div>
</template>

<script>
import TestConditionModal from '@stu/views/member/components/TestConditionModal';
import TestingModal from '@stu/views/test/components/TestingModal';
export default {
  name: 'CourseExam',
  components: {
    TestConditionModal,
    TestingModal,
  },
  props: {
    exam: {
      type: Object,
      default: () => {
        return {};
      },
    },
    courseId: {
      type: Number,
    },
  },
  data() {
    return {
      testCondition: {
        name: '',
        courseList: [],
      },
      showModal: false,
      showTipsModal: false,
      remindType: {
        type: 3,
      },
    };
  },
  computed: {
    showJoinBtn() {
      /**
       * status
       *  1:未报名课程，
       *  2:报名未参加考试，
       *  3:报名，考试已达上限，
       *  4:已参与考试，试卷处于待批阅状态，
       *  5:已参与考试，已出结果，未达考试次数上限
       *  6:继续考试（答题未提交，继续上一次继续做题）
       */
      return this.exam.status == 2 || this.exam.status == 5 || this.exam.status == 6;
    },
    showDetailBtn() {
      return this.exam.report_id;
    },
  },
  methods: {
    async joinTest() {
      let data = await this.$http.get(`/api/app/test/doTest/${this.exam.id}/${this.courseId}`);
      /**
       * isFinishCondition
       * 0:未达到考试条件--弹框显示考试条件
       * 1:满足条件--跳至考试说明页
       * 2:未购买课程--弹框提示
       * 3:课程已过期--弹框提示
       * 4:当前考试已被下架
       * 5:考试次数已达到上限
       */
      if (data.isFinishCondition > 2) {
        if (data.isFinishCondition == 3) {
          this.remindType.type = 5;
        } else if (data.isFinishCondition == 4) {
          this.remindType.type = 3;
        } else {
          this.remindType.type = 6;
        }
        this.showTipsModal = true;
        return;
      }
      if (!data.isFinishCondition) {
        data.conditionDetail.map((item) => {
          item.course_title = item.title;
        });
        this.testCondition = {
          name: this.exam.name,
          courseList: data.conditionDetail || [],
          join_type: data.conditionType,
        };
        this.showModal = true;
        return;
      }
      // 答题未提交可继续考试
      if (this.exam.status == 6) {
        this.$router.push({
          name: 'TestDo',
          query: {
            id: this.exam.draft_report_id,
            package_id: this.exam.id,
          },
        });
        return;
      }
      // 符合条件的跳至考试说明页
      this.$router.push({ name: 'TestDetail', query: { id: this.exam.id } });
    },
    toDetail() {
      this.$router.push({
        name: 'TestReport',
        params: { id: this.exam.report_id },
      });
    },
    notBuyTips() {
      if (this.exam.status == 1) {
        this.$message.warning('请先报名课程，才能参与考试');
        return;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.exam-item {
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: PingFang SC, PingFang SC-Regular;
  &.not-buy {
    cursor: pointer;
  }
  .exam-left {
    display: flex;
    align-items: center;
    max-width: 590px;
  }
  .exam-icon {
    width: 38px;
    height: 38px;
    margin-right: 16px;
  }
  .exam-title {
    color: #333333;
    font-weight: 600;
  }
  .num-score {
    color: #999999;
    margin-top: 10px;
    display: flex;
    align-items: center;
    .line-score {
      width: 1px;
      height: 14px;
      margin: 0 14px;
      background: #999999;
    }
  }
  .exam-right {
    span {
      display: inline-block;
      width: 104px;
      height: 36px;
      line-height: 36px;
      border: 1px solid #cccccc;
      border-radius: 32px;
      text-align: center;
      color: #666666;
      outline: none;
      cursor: pointer;
      margin-left: 0;
    }
    .active {
      background-color: $primary-color;
      color: #ffffff;
      border: 1px solid $primary-color;
      margin-left: 20px;
    }
  }
}
</style>
